import { render } from "./ProductQuantityAlertPage.vue?vue&type=template&id=5d8519ac&scoped=true&ts=true"
import script from "./ProductQuantityAlertPage.vue?vue&type=script&lang=ts"
export * from "./ProductQuantityAlertPage.vue?vue&type=script&lang=ts"

import "./ProductQuantityAlertPage.vue?vue&type=style&index=0&id=5d8519ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8519ac"]])

export default __exports__